import { render, staticRenderFns } from "./UploadFirestoragePage.vue?vue&type=template&id=9132b9e4&scoped=true&"
import script from "./UploadFirestoragePage.vue?vue&type=script&lang=js&"
export * from "./UploadFirestoragePage.vue?vue&type=script&lang=js&"
import style0 from "./UploadFirestoragePage.vue?vue&type=style&index=0&id=9132b9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9132b9e4",
  null
  
)

export default component.exports